import { CommandDispatcher } from "@/modules/shared/domain/CommandDispatcher";

export class DespuntearTransactionEffectsCommand {
  constructor(
    private readonly dispatcher: CommandDispatcher,
    private readonly frontend,
  ) { }

  async run(transaction_ids:string[]): Promise<any> {
    let args: any = { 
      action: 'despuntear',
      transaction_ids: transaction_ids,
      effect_ids: []
    }
    
    this.frontend.despuntearLoading = true;    
    let res = await this.dispatcher.dispatch('puntear.transaction', args);
    const outputs = Array.isArray(res.output) ? res.output : (res.output ? [res.output] : []);
    for (const out of outputs) {
      if (out && out.id) {
        for (let i in this.frontend.transactions_list) {
          if (this.frontend.transactions_list[i].id == out.id) {
            this.frontend.transactions_list[i].contrapartida = out.contrapartida
            this.frontend.transactions_list[i].contains_effects = out.contains_effects;
          }
        }
      }
    }
    this.frontend.despuntearLoading = false;
  }
}